type CouponServiceLike = {
  getAllCouponPasses: (forceRefresh?: boolean) => Promise<any[]>;
  getAllCouponCodes: () => Promise<any[]>;
  getAllPassCodes: () => Promise<any[]>;
};

type LoadCouponDashboardDataOptions = {
  couponService: CouponServiceLike;
  forceCouponPassRefresh?: boolean;
};

export async function loadCouponDashboardData({
  couponService,
  forceCouponPassRefresh = false,
}: LoadCouponDashboardDataOptions) {
  const [couponPasses, couponCodes, passCodesResult] = await Promise.all([
    couponService.getAllCouponPasses(forceCouponPassRefresh),
    couponService.getAllCouponCodes(),
    couponService.getAllPassCodes().then(
      (passCodes) => ({ passCodes, passCodesError: null }),
      (passCodesError) => ({ passCodes: [], passCodesError })
    ),
  ]);

  return {
    couponPasses,
    couponCodes,
    passCodes: passCodesResult.passCodes,
    passCodesError: passCodesResult.passCodesError,
  };
}
